import { ACTIONS } from '../constants/service-types';
import { MODE } from '../constants/mode';

const INITIAL_STATE = {
  serviceTypesList: { serviceTypes: [], params: {}, pager: null, error: null, loading: false },
  activeServiceType: { serviceType: null, error: null, mode: null },
};

export const serviceTypes = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    /*──────────────────────── RESET single service-type state ───────────────────────*/
    case ACTIONS.SERVICE_TYPE_CREATE_RESET:
    case ACTIONS.SERVICE_TYPE_UPDATE_RESET:
    case ACTIONS.SERVICE_TYPE_DELETE_RESET:
    case ACTIONS.SERVICE_TYPE_FETCH_RESET:
      return {
        ...state,
        activeServiceType: {
          serviceType: null,
          loading: false,
          error: null,
          mode: null,
        },
      };

    /*──────────────────────── CREATE ───────────────────────*/
    case ACTIONS.SERVICE_TYPE_CREATE_START:
      return {
        ...state,
        activeServiceType: {
          serviceType: action.payload,
          loading: true,
          error: null,
          mode: MODE.CREATE,
        },
      };

    case ACTIONS.SERVICE_TYPE_CREATE_FAILURE:
      return {
        ...state,
        activeServiceType: {
          serviceType: null,
          loading: false,
          error: action.payload,
          mode: MODE.CREATE,
        },
      };

    case ACTIONS.SERVICE_TYPE_CREATE_SUCCESS:
      return {
        ...state,
        serviceTypesList: {
          ...state.serviceTypesList,
          serviceTypes: state.serviceTypesList.serviceTypes.concat(action.payload),
          error: null,
          loading: false,
        },
        activeServiceType: {
          serviceType: action.payload,
          loading: false,
          error: null,
          mode: MODE.CREATE,
        },
      };

    /*──────────────────────── UPDATE ───────────────────────*/
    case ACTIONS.SERVICE_TYPE_UPDATE_START:
      return {
        ...state,
        activeServiceType: {
          serviceType: action.payload,
          loading: true,
          error: null,
          mode: MODE.UPDATE,
        },
      };

    case ACTIONS.SERVICE_TYPE_UPDATE_FAILURE:
      return {
        ...state,
        activeServiceType: {
          serviceType: null,
          loading: false,
          error: action.payload,
          mode: MODE.UPDATE,
        },
      };

    case ACTIONS.SERVICE_TYPE_UPDATE_SUCCESS:
      return {
        ...state,
        serviceTypesList: {
          ...state.serviceTypesList,
          serviceTypes: state.serviceTypesList.serviceTypes.map(t =>
            t.id === action.payload.id ? action.payload : t
          ),
          error: null,
          loading: false,
        },
        activeServiceType: {
          serviceType: action.payload,
          loading: false,
          error: null,
          mode: MODE.UPDATE,
        },
      };

    /*──────────────────────── DELETE ───────────────────────*/
    case ACTIONS.SERVICE_TYPE_DELETE_START:
      return {
        ...state,
        activeServiceType: {
          serviceType: action.payload,
          loading: true,
          error: null,
          mode: MODE.DELETE,
        },
      };

    case ACTIONS.SERVICE_TYPE_DELETE_FAILURE:
      return {
        ...state,
        activeServiceType: {
          serviceType: null,
          loading: false,
          error: action.payload,
          mode: MODE.DELETE,
        },
      };

    case ACTIONS.SERVICE_TYPE_DELETE_SUCCESS:
      return {
        ...state,
        serviceTypesList: {
          ...state.serviceTypesList,
          serviceTypes: state.serviceTypesList.serviceTypes.filter(t => t.id !== action.payload.id),
          error: null,
          loading: false,
        },
        activeServiceType: {
          serviceType: action.payload,
          loading: false,
          error: null,
          mode: MODE.DELETE,
        },
      };

    /*──────────────────────── FETCH single ───────────────────────*/
    case ACTIONS.SERVICE_TYPE_FETCH_START:
      return {
        ...state,
        activeServiceType: {
          serviceType: action.payload,
          loading: true,
          error: null,
          mode: MODE.VIEW,
        },
      };

    case ACTIONS.SERVICE_TYPE_FETCH_FAILURE:
      return {
        ...state,
        activeServiceType: {
          serviceType: null,
          loading: false,
          error: action.payload,
          mode: MODE.VIEW,
        },
      };

    case ACTIONS.SERVICE_TYPE_FETCH_SUCCESS:
      return {
        ...state,
        activeServiceType: {
          serviceType: action.payload,
          loading: false,
          error: null,
          mode: MODE.VIEW,
        },
      };

    /*──────────────────────── FETCH list ───────────────────────*/
    case ACTIONS.SERVICE_TYPES_FETCH_START:
      return {
        ...state,
        serviceTypesList: {
          serviceTypes: [],
          params: action.payload,
          pager: null,
          error: null,
          loading: true,
        },
      };

    case ACTIONS.SERVICE_TYPES_FETCH_SUCCESS:
      return {
        ...state,
        serviceTypesList: {
          ...state.serviceTypesList,
          serviceTypes: action.payload.results,
          pager: action.payload.paginator,
          error: null,
          loading: false,
        },
      };

    case ACTIONS.SERVICE_TYPES_FETCH_FAILURE:
      return {
        ...state,
        serviceTypesList: {
          ...state.serviceTypesList,
          serviceTypes: [],
          pager: null,
          error: action.payload,
          loading: false,
        },
      };

    case ACTIONS.SERVICE_TYPES_FETCH_RESET:
      return {
        ...state,
        serviceTypesList: {
          serviceTypes: [],
          params: null,
          pager: null,
          error: null,
          loading: false,
        },
      };

    /*──────────────────────── default ───────────────────────*/
    default:
      return state;
  }
};
